module.exports = __webpack_public_path__ + "b48153996ea4251ffb69438676bcfe38.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/history/2.jpg
// module id = 328
// module chunks = 0